import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent, useState } from 'react'
import { LayoutChangeEvent, useWindowDimensions } from 'react-native'
import RenderHtml from 'react-native-render-html'
import WebView from 'react-native-webview'
import { baseStyle, classesStyles, computeEmbeddedMaxWidth, renderers, renderersProps, tagsStyles } from '../../lib/htmlRenderConfig'
import { linkify } from '../../lib/linkify'
import { theme } from '../../theme'

interface HtmlWebViewProps {
  content: string | null
}

const HtmlWebView: FunctionComponent<HtmlWebViewProps> = ({ content }) => {
  const { width } = useWindowDimensions()
  const [containerWidth, setContainerWidth] = useState<number>()

  if (!content) return null

  const onLayout = (event: LayoutChangeEvent) => setContainerWidth(event.nativeEvent.layout.width)

  return (
    <View style={{ marginTop: theme.padding.x2 }} onLayout={onLayout}>
      <RenderHtml
        source={{ html: linkify(content) }}
        contentWidth={containerWidth || width || 300}
        baseStyle={baseStyle}
        tagsStyles={tagsStyles}
        classesStyles={classesStyles}
        renderersProps={renderersProps}
        renderers={renderers}
        computeEmbeddedMaxWidth={computeEmbeddedMaxWidth}
        WebView={WebView}
        enableExperimentalMarginCollapsing
        enableExperimentalBRCollapsing
      />
    </View>
  )
}

export { HtmlWebView }
